// @material-ui/core
import { Grid } from "@material-ui/core";
// @material-ui/styles
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import "./App.css";
// custom
import MainBar from "./appBar/MainBar";
import MainMenu from "./appBar/MainMenu";
import Switcher from "./library/helper/Switcher";
import Caba from "./services/Caba";

// assets

const styles = theme => ({
  root: {
    width: "100vw",
    height: "100vh",
    marginTop: 0,
    // zIndex: 1,
    overflow: "hidden"
  },
  rootGrid: {
    flexGrow: 1,
    marginBottom: 7 * theme.spacing.unit
  },
  appFrame: {
    position: "relative",
    display: "flex",
    width: "100%",
    height: "100%"
  },
  content: {
    overflowY: "auto",
    width: `calc(100% - ${7 * theme.spacing.unit}px)`,
    marginTop: 7 * theme.spacing.unit,
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    paddingTop: 7 * theme.spacing.unit,
    paddingRight: 2 * theme.spacing.unit,
    paddingLeft: 2 * theme.spacing.unit,
    paddingBottom: 0,
    [theme.breakpoints.up("sm")]: {
      marginTop: 8 * theme.spacing.unit
    }
  },
  contentShift: {
    marginLeft: 0,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    })
  }
});

class App extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
    notify: PropTypes.func.isRequired,
    setLogin: PropTypes.func.isRequired
  };

  state = {
    loggedIn: false,
    open: false,
    isAutoClose: true,
    loading: false,
    error: null,
    showError: false,
    success: null,
    showSuccess: false,
    isAdmin: Caba.isAdmin()
  };

  handleDrawerOpen = () => {
    this.setState({ open: true, isAutoClose: false });
  };

  handleToggle = () => {
    this.setState(prevState => ({
      open: !prevState.open
    }));
  };

  handleAutoClose = () => {
    this.setState(prevState => ({
      isAutoClose: !prevState.isAutoClose
    }));
  };

  handleClose = () => {
    if (this.state.isAutoClose) this.setState({ open: false });
  };

  handleOpen = () => {
    this.setState({ open: true });
  };

  toggleLoading = state => {
    this.setState({ loading: state });
  };

  render() {
    const { classes } = this.props;
    // const { isAdmin } = this.state;

    return (
      <Router>
        <div className={classes.root}>
          <div className={classes.appFrame}>
            <MainMenu
              open={this.state.open}
              isAutoClose={this.state.isAutoClose}
              handleToggle={this.handleToggle}
              handleAutoClose={this.handleAutoClose}
              handleClose={this.handleClose}
            />
            <MainBar
              open={this.state.open}
              isAutoClose={this.state.isAutoClose}
              handleToggle={this.handleAutoClose}
              handleAutoClose={this.handleAutoClose}
              handleOpen={this.handleOpen}
              clientId={this.props.clientId}
              loading={this.state.loading}
            />
            <main
              className={classNames(
                classes.content,
                this.state.open && classes.contentShift
              )}>
              <Grid container spacing={8} className={classes.rootGrid}>
                <Grid item xs={12} md={1} lg={2} />
                <Grid item xs={12} md={10} lg={8}>
                  <Switcher
                    viewProps={{
                      notify: this.props.notify,
                      toggleLoading: this.toggleLoading,
                      isLoading: this.state.loading,
                      setLogin: this.props.setLogin
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={1} lg={2} />
              </Grid>
            </main>
          </div>
        </div>
      </Router>
    );
  }
}

export default withStyles(styles, { withTheme: true })(App);



// WEBPACK FOOTER //
// ./src/App.js